import elliemaeApi from "./interceptors/elliemaeApi";

const getResidenceUrl = (loanId, applicationId, type) =>
    `/encompass/v3/loans/${loanId}/applications/${applicationId}/${type}/residences`;

const fetchResidences = async (token, loanId, applicationId, type) => {
    const url = getResidenceUrl(loanId, applicationId, type);

    const response = await elliemaeApi.request({
        method: 'get',
        url,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    return response.data || [];
};

const sanitizeResidenceForPatch = (r) => ({
    id: r.id || "",
    residencyType: r.residencyType || "",
    addressStreetLine1: r.addressStreetLine1 || "",
    addressCity: r.addressCity || "",
    addressState: r.addressState || "",
    addressPostalCode: r.addressPostalCode || "",
    addressUnitIdentifier: r.addressUnitIdentifier || "",
    county: r.county || "",
    durationTermMonths: r.durationTermMonths ?? 0,
    durationTermYears: r.durationTermYears ?? 0,
    residencyBasisType: r.residencyBasisType || "",
    urla2020StreetAddress: r.urla2020StreetAddress || "",
    country: r.country || "",
    countryCode: r.countryCode || "",
    foreignAddressIndicator: r.foreignAddressIndicator ?? false
});

const splitResidences = (newData, existingData) => {
    const addList = [];
    const updateList = [];

    for (const r of newData) {
        const match = existingData.find(e => e.residencyType === r.residencyType);

        if (match) {
            const merged = {
                ...match,
                ...r,
                id: match.id,

                addressStreetLine1: r.addressStreetLine1 ?? match.addressStreetLine1 ?? "",
                addressCity: r.addressCity ?? match.addressCity ?? "",
                addressState: r.addressState ?? match.addressState ?? "",
                addressPostalCode: r.addressPostalCode ?? match.addressPostalCode ?? "",
                urla2020StreetAddress: r.urla2020StreetAddress ?? match.urla2020StreetAddress ?? "",
                addressUnitIdentifier: r.addressUnitIdentifier ?? match.addressUnitIdentifier ?? "",
                county: r.county ?? match.county ?? "",
                country: r.country ?? match.country ?? "",
                countryCode: r.countryCode ?? match.countryCode ?? "",
                foreignAddressIndicator: r.foreignAddressIndicator ?? match.foreignAddressIndicator ?? false,
                durationTermMonths: r.durationTermMonths ?? match.durationTermMonths ?? 0,
                durationTermYears: r.durationTermYears ?? match.durationTermYears ?? 0,
                residencyBasisType: r.residencyBasisType ?? match.residencyBasisType ?? ""
            };

            updateList.push(sanitizeResidenceForPatch(merged));
        } else {
            addList.push(sanitizeResidenceForPatch(r));
        }
    }

    return { addList, updateList };
};

const submitResidenceGroup = async ({ token, loanId, applicationId, type, addList, updateList }) => {
    const baseUrl = getResidenceUrl(loanId, applicationId, type);

    if (addList.length > 0) {
        const addPayload = addList.map(sanitizeResidenceForPatch);

        console.log(`[Residence Add] ${type}`, JSON.parse(JSON.stringify(addPayload)));

        await elliemaeApi.request({
            method: 'patch',
            url: `${baseUrl}?action=add&view=entity`,
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: addPayload
        });
    }

    if (updateList.length > 0) {
        const updatePayload = updateList.map(sanitizeResidenceForPatch);

        console.log(`[Residence Update] ${type}`, JSON.parse(JSON.stringify(updatePayload)));

        await elliemaeApi.request({
            method: 'patch',
            url: `${baseUrl}?action=update&view=entity`,
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: updatePayload
        });

        await elliemaeApi.request({
            method: 'patch',
            url: `${baseUrl}?action=update&view=entity`,
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: updatePayload
        });
    }
};

export const submitResidences = async ({
    token,
    loanId,
    applicationId,
    borrowerResidences,
    coborrowerResidences
}) => {
    console.log('[submitResidences] borrowerResidences in', JSON.parse(JSON.stringify(borrowerResidences)));
    console.log('[submitResidences] coborrowerResidences in', JSON.parse(JSON.stringify(coborrowerResidences)));

    const borrowerExisting = await fetchResidences(token, loanId, applicationId, 'borrower');
    const coborrowerExisting = await fetchResidences(token, loanId, applicationId, 'coborrower');

    console.log('[submitResidences] borrowerExisting', JSON.parse(JSON.stringify(borrowerExisting)));
    console.log('[submitResidences] coborrowerExisting', JSON.parse(JSON.stringify(coborrowerExisting)));

    const {
        addList: borrowerAdd,
        updateList: borrowerUpdate
    } = splitResidences(borrowerResidences, borrowerExisting);

    const {
        addList: coborrowerAdd,
        updateList: coborrowerUpdate
    } = splitResidences(coborrowerResidences, coborrowerExisting);

    console.log('[submitResidences] borrowerAdd', JSON.parse(JSON.stringify(borrowerAdd)));
    console.log('[submitResidences] borrowerUpdate', JSON.parse(JSON.stringify(borrowerUpdate)));
    console.log('[submitResidences] coborrowerAdd', JSON.parse(JSON.stringify(coborrowerAdd)));
    console.log('[submitResidences] coborrowerUpdate', JSON.parse(JSON.stringify(coborrowerUpdate)));

    await submitResidenceGroup({
        token,
        loanId,
        applicationId,
        type: 'borrower',
        addList: borrowerAdd,
        updateList: borrowerUpdate
    });

    await submitResidenceGroup({
        token,
        loanId,
        applicationId,
        type: 'coborrower',
        addList: coborrowerAdd,
        updateList: coborrowerUpdate
    });
};